import { useActiveShift } from '@/lib/shift-cache';
import { ScreenHeader, Spinner } from '@/components/ui';
import { StartScreen } from './StartScreen';
import { RouteScreen } from './RouteScreen';

export default function HomeScreen() {
  const { data, isPending, isError } = useActiveShift();

  if (data) return <RouteScreen data={data} />;
  if (data === null) return <StartScreen />;
  // Первый запуск без сети: ни кэша, ни ответа сервера.
  return (
    <>
      <ScreenHeader title="Маршрут" />
      {isPending && !isError ? (
        <Spinner />
      ) : (
        <p className="mx-auto max-w-md px-6 py-16 text-center text-sm text-ink/55">Нет связи с сервером. Как только появится сеть, здесь будет ваша смена.</p>
      )}
    </>
  );
}
